const _excluded = ["children", "rtl", "className", "isDetSite"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import './SystemMessageBanner.css';
import React from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../../utils';
import { Link, Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../../atoms/ComponentsWrapper';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
const SystemMessageBanner = _ref2 => {
  let {
    fields,
    params
  } = _ref2;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const [isVdsite, setIsVdsite] = React.useState(true);
  const isDetSite = get(params, 'RenderingStyle') === 'DDA' || false;
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (!fields) {
    console.warn('BannerLarge component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[BannerLarge component is empty: please provide data source]");
    }
    return null;
  }
  const buttonClickAnalytics = get(fields, 'data.buttonClickAnalytics');
  const item = get(fields, 'data.item') || {};
  const title = get(fields, 'data.item.title.jss.value');
  const hasTitle = Boolean(get(item, 'title.jss.value'));
  const hasDescription = Boolean(get(item, 'description.jss.value'));
  const ctaLabel = get(item, 'ctaLabel.jss.value', '');
  const ctaAnalytics = get(item, 'ctaAnalytics.jss.value', '');
  const ctaLinkHref = get(item, 'ctaLink.jss.value.href', '');
  const ctaLinkTitle = get(item, 'ctaLink.jss.value.title', '');
  const colourTheme = get(params, 'Color', get(item, 'colourTheme.jss.fields.themeName.value', 'theme-1'));
  const icon = get(item, 'iconSvgCode.jss.value');
  const headerTitle = get(item, 'headerTitle.jss.value');
  const headerDescription = get(item, 'headerDescription.jss.value');
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex', '');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const defaultColors = {
    global: {
      bgColor: '#FFFFFF',
      borderColor: '#ABACAE',
      titleColor: '#000000',
      descColor: '#000000',
      iconColor: primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
      buttonBg: '#FFFFFF',
      buttonBgActive: primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
      buttonColor: primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
      buttonColorActive: '#FFFFFF',
      buttonBorderColor: primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
      buttonBorderColorActive: primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active
    },
    dda: {
      bgColor: '#FBF8FD',
      borderColor: '#E4E2E6',
      titleColor: '#000000',
      descColor: '#40484F',
      iconColor: '#40484F',
      buttonBg: primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
      buttonBgActive: primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
      buttonColor: '#FFFFFF',
      buttonColorActive: '#FFFFFF',
      buttonBorderColor: primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
      buttonBorderColorActive: primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active
    }
  };
  const styleThemeHexColor = BackgroundColorHex ? {
    '--banner-system-background-color': BackgroundColorHex,
    '--banner-system-background-active-color': ActiveColorHex,
    '--banner-system-border-color': BackgroundColorHex,
    '--banner-system-color': ColorHex ? ColorHex : getColorByTheme(BackgroundColorHex),
    '--banner-system-title-color': ColorHex ? ColorHex : getColorByTheme(BackgroundColorHex),
    '--banner-system-desc-color': ColorHex ? ColorHex : getColorByTheme(BackgroundColorHex),
    '--banner-system-icon-color': ColorHex ? ColorHex : getColorByTheme(BackgroundColorHex),
    '--banner-system-button-bg': ColorHex ? ColorHex : getColorByTheme(BackgroundColorHex),
    '--banner-system-button-bg-active': ActiveColorHex,
    '--banner-system-button-color': BackgroundColorHex,
    '--banner-system-button-color-active': ColorHex ? ColorHex : getColorByTheme(BackgroundColorHex),
    '--banner-system-button-border-color': ColorHex ? ColorHex : getColorByTheme(BackgroundColorHex),
    '--banner-system-button-border-color-active': ActiveColorHex
  } : {
    '--banner-system-background-color': defaultColors[isDetSite ? 'dda' : 'global'].bgColor,
    '--banner-system-background-active-color': defaultColors[isDetSite ? 'dda' : 'global'].bgColor,
    '--banner-system-border-color': defaultColors[isDetSite ? 'dda' : 'global'].borderColor,
    '--banner-system-color': defaultColors[isDetSite ? 'dda' : 'global'].titleColor,
    '--banner-system-title-color': defaultColors[isDetSite ? 'dda' : 'global'].titleColor,
    '--banner-system-desc-color': defaultColors[isDetSite ? 'dda' : 'global'].descColor,
    '--banner-system-icon-color': defaultColors[isDetSite ? 'dda' : 'global'].iconColor,
    '--banner-system-button-bg': defaultColors[isDetSite ? 'dda' : 'global'].buttonBg,
    '--banner-system-button-bg-active': defaultColors[isDetSite ? 'dda' : 'global'].buttonBgActive,
    '--banner-system-button-color': defaultColors[isDetSite ? 'dda' : 'global'].buttonColor,
    '--banner-system-button-color-active': defaultColors[isDetSite ? 'dda' : 'global'].buttonColorActive,
    '--banner-system-button-border-color': defaultColors[isDetSite ? 'dda' : 'global'].buttonBorderColor,
    '--banner-system-button-border-color-active': defaultColors[isDetSite ? 'dda' : 'global'].buttonBorderColorActive
  };
  const ctaLeftIcon = get(fields, 'data.item.ctaLeftIcon.targetItem.svg.jss.value');
  const ctaRightIcon = get(fields, 'data.item.ctaRightIcon.targetItem.svg.jss.value');
  const renderLink = () => {
    if (pageEditing) return /*#__PURE__*/React.createElement("button", {
      "data-testid": "banner-large-editing-cta-link",
      className: "btn btn-secondary"
    }, /*#__PURE__*/React.createElement(Link, {
      field: item.ctaLink
    }));
    if (!ctaLabel || !ctaLinkHref) return null;
    return /*#__PURE__*/React.createElement("a", {
      className: "btn btn-secondary banner-btn",
      href: ctaLinkHref,
      "aria-label": `${title} - ${ctaLabel}`,
      onClick: () => tealiumClickFunc(tealiumMergeClickData(buttonClickAnalytics, params), ctaAnalytics)
    }, ctaLeftIcon ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: ctaLeftIcon
      },
      className: "ctaLeftIcon"
    }) : /*#__PURE__*/React.createElement(React.Fragment, null), ctaLabel, ctaRightIcon ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: ctaRightIcon
      },
      className: "ctaRightIcon"
    }) : /*#__PURE__*/React.createElement(React.Fragment, null));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isDetSite: isDetSite
  }, headerTitle && /*#__PURE__*/React.createElement("h4", {
    className: "banner-header-title"
  }, headerTitle), headerDescription && /*#__PURE__*/React.createElement("p", {
    className: "banner-header-decription"
  }, headerDescription), /*#__PURE__*/React.createElement("div", {
    className: "row banner banner--error banner-system",
    "data-cy": "banner-large",
    style: styleThemeHexColor
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 col-lg-12 col-xl-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: `banner__card ${colourTheme} theme-contrast`
  }, icon ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: icon
    },
    className: "banner__icon"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("div", {
    className: "banner__wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "banner__text"
  }, hasTitle && /*#__PURE__*/React.createElement("div", {
    className: "banner__header",
    "data-cy": "banner-large-title"
  }, /*#__PURE__*/React.createElement(Text, {
    className: isDetSite ? 'h4' : 'h1',
    tag: isDetSite ? 'h4' : 'h1',
    field: get(item, 'title.jss')
  })), hasDescription && /*#__PURE__*/React.createElement("div", {
    className: "banner__body",
    "data-cy": "banner-large-description"
  }, /*#__PURE__*/React.createElement(RichText, {
    className: "body-large",
    tag: "div",
    field: get(item, 'description.jss')
  }))), /*#__PURE__*/React.createElement("div", {
    className: "banner__footer",
    "data-cy": "banner-large-cta"
  }, renderLink())))), /*#__PURE__*/React.createElement("div", {
    className: "col-md"
  })));
};
const StyledWrapper = _ref => {
  let {
      children,
      rtl,
      className,
      isDetSite
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const systemStyles = isDetSite ? "snig8s4" : "s1trv7gu";
  const ltrStyles = isDetSite ? "lkiaap9" : "l1qim17o";
  const rtlStyles = isDetSite ? "r1d3atrr" : "r1m30vrs";
  return /*#__PURE__*/React.createElement(ComponentsWrapper, _extends({
    className: ` ${systemStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, otherProps), children);
};
export default SystemMessageBanner;